import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { phoneHref, whatsappHref } from "@/lib/data";

export default function Footer({ content }) {
  const phone = content?.phone || "07378114330";
  return (
    <footer className="bg-[#04070c] text-[#f0f4f8] py-16 border-t border-[#1e9bff]/20" data-testid="footer">
      <div className="max-w-6xl mx-auto px-4 grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
        <div>
          <div className="mb-3">
            <Logo className="w-6 h-6" withText={false} />
            <span className="font-display text-lg text-white uppercase block mt-2">SY Exterior</span>
          </div>
          <p className="text-xs text-[#93b4d4] font-mono-lbl mb-2">South Yorkshire, United Kingdom</p>
          <div className="inline-block px-2.5 py-1 rounded bg-[#1e9bff]/10 border border-[#1e9bff]/30 text-[10px] font-mono-lbl text-[#1e9bff] uppercase tracking-wider" data-testid="footer-insured-badge">
            Fully Insured
          </div>
        </div>
        <div>
          <span className="text-xs font-mono-lbl text-[#1e9bff] uppercase tracking-wider block mb-3">Contact</span>
          <p className="text-xs text-white mb-1 font-mono-lbl">
            Phone: <a href={phoneHref(phone)} data-testid="footer-phone-link" className="hover:text-[#1e9bff] transition-colors">{phone}</a>
          </p>
          <p className="text-xs text-[#93b4d4] font-mono-lbl break-all">
            Email: <a href={`mailto:${content?.email}`} data-testid="footer-email-link" className="hover:text-[#1e9bff] transition-colors">{content?.email}</a>
          </p>
          {(content?.facebook_url || content?.instagram_url) && (
            <div className="flex gap-3 mt-3">
              {content.facebook_url && (
                <a href={content.facebook_url} target="_blank" rel="noopener noreferrer" data-testid="footer-facebook-link" className="text-[#93b4d4] hover:text-[#1e9bff] transition-colors" aria-label="Facebook">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M22 12a10 10 0 10-11.6 9.9v-7H7.9V12h2.5V9.8c0-2.5 1.5-3.9 3.8-3.9 1.1 0 2.2.2 2.2.2v2.5h-1.3c-1.2 0-1.6.8-1.6 1.6V12h2.8l-.4 2.9h-2.4v7A10 10 0 0022 12z"/></svg>
                </a>
              )}
              {content.instagram_url && (
                <a href={content.instagram_url} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram-link" className="text-[#93b4d4] hover:text-[#1e9bff] transition-colors" aria-label="Instagram">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><rect x="2" y="2" width="20" height="20" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="0.5" fill="currentColor"/></svg>
                </a>
              )}
            </div>
          )}
        </div>
        <div>
          <span className="text-xs font-mono-lbl text-[#1e9bff] uppercase tracking-wider block mb-3">Services</span>
          <ul className="text-xs text-[#93b4d4] space-y-1 font-mono-lbl">
            <li><Link to="/services/driveways" className="hover:text-white transition-colors">Driveways &amp; Patios</Link></li>
            <li><Link to="/services/gutters" className="hover:text-white transition-colors">Gutter Vacuuming</Link></li>
            <li><Link to="/services/fascia-soffits" className="hover:text-white transition-colors">Fascias &amp; Soffits</Link></li>
            <li><Link to="/services/roofs" className="hover:text-white transition-colors">Roof Moss Scrape</Link></li>
          </ul>
        </div>
        <div>
          <span className="text-xs font-mono-lbl text-[#1e9bff] uppercase tracking-wider block mb-3">Messaging</span>
          <a
            href={whatsappHref(phone)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp-btn"
            className="block w-full py-2.5 px-4 rounded-xl bg-emerald-500/20 border border-emerald-500/40 text-emerald-400 font-mono-lbl text-xs uppercase tracking-wider hover:bg-emerald-500/30 transition-colors text-center"
          >
            Chat on WhatsApp
          </a>
        </div>
      </div>
      <div className="max-w-6xl mx-auto px-4 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between text-[11px] font-mono-lbl text-[#627d98]">
        <p>© 2025 SY Exterior Cleaning. All rights reserved.</p>
        <div className="flex gap-4 mt-2 sm:mt-0">
          <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-white transition-colors">Privacy Policy</Link>
          <a href="#booking" data-testid="footer-cookie-link" className="hover:text-white transition-colors">Cookie Settings</a>
        </div>
      </div>
    </footer>
  );
}
